import React, { useEffect, useContext, useState } from 'react';
import { appContext } from "./../../../AppContext";
import {useFetch} from '../../../utils/hooks/useFetch'
import { Table, Spin, message, Input, Button } from 'antd';
import RaceModal from '../admin/modals/RaceModal';
import TextEditorReadOnly from '../../text/TextEditorReadOnly';
import { sortByString } from '../../../utils/functions/Sorters';
const { Search } = Input;

export default function RaceAdmin() {

     const [appState] = useContext(appContext);
     const [doFetch] = useFetch();
     const[isLoading, setIsLoading] = useState(true)
     const [searchValue, setSearchValue] = useState("");
     const [dataSource, setDataSource] = useState([]);
     const [result, setResult] = useState([])
     const [isModalVisible, setIsModalVisible] = useState(false);
     const [selectedRecord, setSelectedRecord] = useState({});

      useEffect(() => {
        if(result.length <= 0) {
          return;
        }
        const newDataSource = result.filter(_ => _.name?.toLowerCase().includes(searchValue.toLowerCase())
        )
        setDataSource(newDataSource);
      }, [result, searchValue])

      useEffect(() => {
        refresh();
          }, // eslint-disable-next-line
      [searchValue, appState.storyId])

      function refresh()
      {
          const url = `/api/race/${appState.storyId}/GetWiki`
          doFetch(url)
          .then((response) => onInventoryLoaded(response.isSuccess, response.result))
  
          function onInventoryLoaded(isSuccess, result) { 
            if(isSuccess) {
              setResult(result);
              setIsLoading(false);
              return;
            }
            setResult([])
            message.error('Could not get Race items');
            setIsLoading(false);
          }
      }

      if(isLoading)
      {
          return <Spin />
      }

      // function onDelete(record)
      // {
      //     // const url = "/api/Inventory/RemoveInventory?inventoryId=" + record.id;
      //     // doFetch(url)
      //     //     .then((response) => onRemoveInventoryLoaded(response.isSuccess))
  
      //     // function onRemoveInventoryLoaded(isSuccess) {
      //     //   isSuccess ? refresh() : message.error('Could not remove Inventory');
      //     // }
      // }

      function onSearch(searchValue)
      {
        setSearchValue(searchValue);
      }

      function onRowClick(record)
      {
        setSelectedRecord(record);
        setIsModalVisible(true);
      }

      const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
              sorter: (a, b) => sortByString(a.name, b.name),
              sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
          title: 'Description',
          dataIndex: 'description',
          key: 'description',
          render: (description) => {
            return (<TextEditorReadOnly content={description}/>)
          },
        }
    ]

    return (
      <>
        <Search
              placeholder="input search text"
              onSearch={onSearch}
              enterButton 
            />
            <Button onClick={refresh} >
              Refresh
            </Button>
            <br />
            <br />
            <Table 
              columns={columns} 
              dataSource={dataSource} 
                  onRow={(record, rowIndex) => {
                    return {
                    onClick: event => {onRowClick(record)}, // click row
                    onDoubleClick: event => {}, // double click row
                    onContextMenu: event => {}, // right button click row
                    onMouseEnter: event => {}, // mouse enter row
                    onMouseLeave: event => {}, // mouse leave row
                    };
                }}
            />

            <RaceModal 
              refresh={refresh}
              setIsModalVisible={setIsModalVisible}
              isModalVisible={isModalVisible}
              record={selectedRecord}
            />  
      </>
    )
}